import { Flex, Form, Typography } from "antd"
import type { FormInstance } from "antd/es/form/hooks/useForm"
import React from "react"

import { budgetFormat } from "../../../utils/number/budget-format.ts"
import { type DocumentFormData } from "../document.types.ts"

const { Text } = Typography

interface DocumentScopeSectionFooterProps {
  form: FormInstance<DocumentFormData>
}

export function DocumentScopeSectionFooter({
  form
}: DocumentScopeSectionFooterProps) {
  const phases = Form.useWatch("project_phases", form) || []

  const totalBudget = phases.reduce(
    (sum: number, item) => sum + +(item?.budget?.budget || 0),
    0
  )

  const calculateTotalTimeline = () => {
    if (!phases.length) return "—"

    const totalDays = phases.reduce(
      (sum: number, phase) => sum + (phase?.duration_days || 0),
      0
    )

    if (totalDays === 0) return "—"
    if (totalDays === 1) return "1 day"

    return `${totalDays} days`
  }

  return (
    <Flex
      align={"center"}
      className={
        "p-3 mt-2 border bg-[var(--ant-table-footer-bg)] border-border rounded-card"
      }
    >
      <div className="flex-1">
        <Text strong>Total</Text>
      </div>
      <div style={{ width: 185 }}>
        <Text strong>{calculateTotalTimeline()}</Text>
      </div>
      <div style={{ width: 225 }}>
        <Text strong ellipsis className="truncate max-w-40">
          {budgetFormat(totalBudget)}
        </Text>
      </div>
      <div style={{ width: 50 }} />
    </Flex>
  )
}
